export default {
	LikedMeTab: "likedme",
	LikesTab: "likes",
};
